<template>
  <div v-if="dataInlandsfluege.length > 0" class="mt-4">
    <h5
      role="button"
      @click="isInlandsfluegeCollapsed = !isInlandsfluegeCollapsed"
      :aria-expanded="isInlandsfluegeCollapsed ? 'true' : 'false'"
      aria-controls="collapse-4"
      class="mb-2 user-select-none"
    >
      <b-icon
        v-if="!isInlandsfluegeCollapsed"
        :scale="0.75"
        icon="chevron-right"
        aria-hidden="true"
      ></b-icon>
      <b-icon v-else :scale="0.75" icon="chevron-down" aria-hidden="true"></b-icon>
      Inlandsflüge
    </h5>
    <hr class="w-100 ml-0" />
    <b-collapse
      id="collapse-4"
      :class="isInlandsfluegeCollapsed ? null : 'collapsed'"
      v-model="isInlandsfluegeCollapsed"
    >
      <div v-for="(data, i) in dataInlandsfluege" :key="'inlandflug-' + i" class="mt-5">
        <h6 class="mb-4 ml-2">{{ i + 1 + '. Inlandsflug' }}</h6>
        <b-list-group
          horizontal
          v-for="item in data"
          :key="'inlandsflug-' + i + item.label"
          class="bv-example-row"
          :style="{ display: !item.show ? 'none' : '' }"
        >
          <b-list-group-item class="col-6 d-flex align-items-center detailLabelGreyedOut" style="">
            <h6 class="my-1 leftLabel">{{ item.label }}</h6>
          </b-list-group-item>
          <b-list-group-item
            class="col-6 d-flex align-items-center"
            :class="'detailLabelGreyedOut'"
            :variant="item.variant"
          >
            <template v-if="item?.editable">
              <b-form-input
                v-if="item.editType === 'input'"
                v-model="item.valueEdited"
                class="border-0 p-2 leftLabel"
                debounce="1000"
                @update="$emit('flugnummer-changed', data)"
                placeholder="-"
              ></b-form-input>
              <b-form-checkbox
                size="lg"
                v-else-if="item.editType === 'checkbox'"
                v-model="item.valueEdited"
                @change="$emit('flugnummer-changed', data)"
              ></b-form-checkbox>
            </template>
            <span v-else-if="item.renderer !== null">
              <span v-html="item.renderer"></span>
            </span>
            <h6 class="my-1 leftLabel" v-else>{{ item.value }}</h6>
          </b-list-group-item>
        </b-list-group>
      </div>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'SidebarFlugplanungInlandsfluege',
  props: {
    // Anzeige-Modell der Inlandsflüge (pro Inlandsflug ein Array von Detail-Feldern)
    dataInlandsfluege: { type: Array, default: () => [] },
  },
  data() {
    return {
      isInlandsfluegeCollapsed: false,
    };
  },
};
</script>

<style scoped>
.detailLabelGreyedOut {
  background-color: rgba(114, 114, 114, 0.05);
  border-style: solid;
  border-color: rgba(114, 114, 114, 0.15);
}

.leftLabel {
  font-size: 1.05rem;
  font-weight: 500;
}

:deep(.form-control) {
  height: 32px !important;
}

.list-group {
  height: 42px;
}
</style>
